import { Menu, MenuItem, Checkbox } from "@mui/material";
import React from "react";
import { OptionType, SubOptionType } from "../../../services/helpers/types";
import { ValueObjectType } from "../../organisms/CascaderField/helpers";
import { getCheckboxChecked } from "./helpers";
import { isThisArrayNotEmpty } from "../../../services/helpers/commonHelpers";

interface CascaderSubOptionsProps {
  currentOption?: OptionType;
  anchorEl: Element | null;
  currentValueObject: ValueObjectType;
  handleSubMenuFocusCapture: (event?: React.FocusEvent<HTMLDivElement>) => void;
  handleSubOptionSelect: (subOption: SubOptionType) => void;
}

const CascaderSubOptions = (props: CascaderSubOptionsProps) => {
  const {
    currentOption,
    anchorEl,
    currentValueObject,
    handleSubMenuFocusCapture,
    handleSubOptionSelect,
  } = props;

  const open = Boolean(anchorEl);

  const id = open ? "dui-popover" : undefined;

  return (
    <Menu
      className="dui-cascader-submenu"
      id={id}
      open={open}
      anchorEl={anchorEl}
      onFocusCapture={handleSubMenuFocusCapture}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transitionDuration={0}
    >
      {currentOption !== undefined &&
      isThisArrayNotEmpty(currentOption.subOptions)
        ? currentOption?.subOptions?.map((subOption: SubOptionType) => (
            <MenuItem
              key={subOption.subOptionID}
              value={`${currentOption.name} - ${subOption.name}`}
              onClick={() => {
                handleSubOptionSelect(subOption);
              }}
              className="dui-cascader-subitem"
            >
              <Checkbox
                checked={getCheckboxChecked(
                  currentOption,
                  subOption.name,
                  currentValueObject
                )}
              />

              {subOption.name}
            </MenuItem>
          ))
        : null}
    </Menu>
  );
};

export default CascaderSubOptions;
